// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResultTile_root__3E_3U"};